module.exports = __webpack_public_path__ + "img/img44.7a5a2683.jpg";